import React, {useState} from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {ReactComponent as CrossIcon} from 'assets/svg/cross.svg';
import {Icon} from 'components/ui-kit/Icon';
import {PillVariant} from 'components/ui-kit/Pills';
import {dashboardState$, dateRangeChanged, dateTypeChanged, resetDates} from 'models/dashboard';
import {breakpoint, colors} from 'theme';
import {DashboardDateType} from 'types';
import {useMatchMedia} from 'utils/custom-hooks';
import {formatDate, getPastDate} from 'utils/date';

import {DateRange} from '../../../ui-kit/DateRange';

import {DateFilter, Root, StyledPill} from './styled';

export const Dates: React.FC = () => {
    const {t} = useTranslation();
    const {dateRange, dateType} = useStore(dashboardState$);
    const isMobile = useMatchMedia(`(max-width: ${breakpoint.phone})`);
    const [periodRange, setPeriodRange] = useState<[Date, Date]>([dateRange.start, dateRange.end]);

    const setDateRange = (daysAgo: number, type: DashboardDateType) => {
        const start = getPastDate(new Date(), daysAgo);
        const end = new Date();
        setPeriodRange([start, end]);
        dateRangeChanged({start, end});
        dateTypeChanged(type);
    };

    const datesFilter = (
        <DateFilter>
            <p>
                {dateRange.start ? formatDate(dateRange.start) : '...'}&nbsp; &mdash; &nbsp;
                {dateRange.end ? formatDate(dateRange.end) : '...'}
            </p>
            <Icon
                onClick={() => resetDates()}
                width={12}
                height={12}
                fillColor={colors.brandPrimary}
                source={CrossIcon}
            />
        </DateFilter>
    );

    return (
        <Root>
            <StyledPill
                isActive={dateType === DashboardDateType.Day}
                variant={PillVariant.text}
                onClick={() => {
                    setDateRange(1, DashboardDateType.Day);
                }}
            >
                {t('pages.dashboard.dates.day')}
            </StyledPill>
            <StyledPill
                isActive={dateType === DashboardDateType.Week}
                variant={PillVariant.text}
                onClick={() => {
                    setDateRange(7, DashboardDateType.Week);
                }}
            >
                {t('pages.dashboard.dates.week')}
            </StyledPill>
            <StyledPill
                isActive={dateType === DashboardDateType.Month}
                variant={PillVariant.text}
                onClick={() => {
                    setDateRange(30, DashboardDateType.Month);
                }}
            >
                {t('pages.dashboard.dates.month')}
            </StyledPill>
            <StyledPill
                isActive={dateType === DashboardDateType.Quarter}
                variant={PillVariant.text}
                onClick={() => {
                    setDateRange(90, DashboardDateType.Quarter);
                }}
            >
                {t('pages.dashboard.dates.quarter')}
            </StyledPill>
            <StyledPill
                isActive={dateType === DashboardDateType.Period}
                variant={PillVariant.text}
                onClick={() => {
                    const [start, end] = periodRange;
                    dateRangeChanged({
                        start,
                        end,
                    });
                    dateTypeChanged(DashboardDateType.Period);
                }}
            >
                {t('pages.dashboard.dates.period')}
            </StyledPill>
            {/* <DatePicker
                onChange={(date) => {
                    if (date instanceof Date) {
                        dateTypeChanged(DashboardDateType.Day);
                        dateRangeChanged({
                            start: getPastDate(date, 1),
                            end: date,
                        });
                    }
                }}
                customInput={
                    <StyledPill
                        isActive={dateType === DashboardDateType.Day}
                        variant={PillVariant.text}
                    >
                        {t('pages.dashboard.dates.day')}
                    </StyledPill>
                }
                shouldCloseOnSelect={true}
                popperPlacement="bottom-start"
            /> */}
            {/* <DatePicker
                onChange={(date) => {
                    if (date instanceof Date) {
                        dateTypeChanged(DashboardDateType.Week);
                        dateRangeChanged({
                            start: getPastDate(date, 7),
                            end: date,
                        });
                    }
                }}
                customInput={
                    <StyledPill
                        isActive={dateType === DashboardDateType.Week}
                        variant={PillVariant.text}
                    >
                        {t('pages.dashboard.dates.week')}
                    </StyledPill>
                }
                shouldCloseOnSelect={true}
                popperPlacement="bottom-start"
            /> */}
            {/* <DatePicker
                onChange={(date) => {
                    if (date instanceof Date) {
                        dateTypeChanged(DashboardDateType.Month);
                        dateRangeChanged({
                            start: getPastDate(date, 30),
                            end: date,
                        });
                    }
                }}
                customInput={
                    <StyledPill
                        isActive={dateType === DashboardDateType.Month}
                        variant={PillVariant.text}
                    >
                        {t('pages.dashboard.dates.month')}
                    </StyledPill>
                }
                shouldCloseOnSelect={true}
                popperPlacement={isMobile ? 'bottom-end' : 'bottom-start'}
            /> */}
            {/* <DatePicker
                onChange={(date) => {
                    if (date instanceof Date) {
                        dateTypeChanged(DashboardDateType.Quarter);
                        dateRangeChanged({
                            start: getPastDate(date, 90),
                            end: date,
                        });
                    }
                }}
                customInput={
                    <StyledPill
                        isActive={dateType === DashboardDateType.Quarter}
                        variant={PillVariant.text}
                    >
                        {t('pages.dashboard.dates.quarter')}
                    </StyledPill>
                }
                shouldCloseOnSelect={true}
                popperPlacement={isMobile ? 'bottom-end' : 'bottom-start'}
            /> */}
            {!isMobile && (
                <DateRange
                    value={periodRange}
                    onChange={(datePair) => {
                        if (datePair) {
                            let [start, end] = datePair;
                            start = start || new Date();
                            end = end || new Date();
                            setPeriodRange([start, end]);
                            dateRangeChanged({
                                start,
                                end,
                            });
                            dateTypeChanged(DashboardDateType.Period);
                        }
                    }}
                />
            )}
            {/*{!isMobile && datesFilter}*/}
        </Root>
    );
};
